
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @generated SignedSource<<b387d58755674457ae4f39adf063ec37>>
 * @relayHash 4d36c161a002817ebf0a774bd870c3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e
const $52181a874b01b0e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentLookAndFeel",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScreenLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "screen",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "background"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundColor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundImage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundPosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundSize"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundRepeat"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundOrigin"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundClip"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundAttachment"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundBlendMode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4d36c161a002817ebf0a774bd870c3f0",
            "id": "e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e",
            "metadata": {},
            "name": "MainLayoutQuery",
            "operationKind": "query",
            "text": "query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id,lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode}}}}}"
        }
    };
}();
$52181a874b01b0e6$var$node.hash = "de3e636b8d3cf59cd103bdc7552ea849";
var $52181a874b01b0e6$export$2e2bcd8739ae039 = $52181a874b01b0e6$var$node;



var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $5ZPtT = parcelRequire("5ZPtT");

/**
 * @generated SignedSource<<aee3d452e700222c207ed3413b38e9d4>>
 * @relayHash b1c5bff520163b91e48e77e975abc312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47
const $4a82a81af9c5e51c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b1c5bff520163b91e48e77e975abc312",
            "id": "808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47",
            "metadata": {},
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "operationKind": "query",
            "text": "query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id,theme{themeKey}}}"
        }
    };
}();
$4a82a81af9c5e51c$var$node.hash = "5414d0003b526de29b97ae12c29148ab";
var $4a82a81af9c5e51c$export$2e2bcd8739ae039 = $4a82a81af9c5e51c$var$node;






var $55fM8 = parcelRequire("55fM8");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");





var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $cozmU.useRef)(null);
    const allAppsLoaded = (0, $cozmU.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const presetTimeoutConfig = (0, $1xpoY.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $1xpoY.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $4a82a81af9c5e51c$export$2e2bcd8739ae039), {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "web-panel-location"
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail_0 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_0));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail_1 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_1));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail_2 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_2));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");








var $gXfti = parcelRequire("gXfti");





















var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $cozmU.useRef)(null);
    const lastLoggedForgePageBannerHeightRef = (0, $cozmU.useRef)(undefined);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
            if (entry) {
                const height = entry.target.clientHeight;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.documentElement.style.setProperty('--forge-page-banner-height', `${height}px`);
                if (lastLoggedForgePageBannerHeightRef.current !== height) {
                    lastLoggedForgePageBannerHeightRef.current = height;
                    (0, $gXfti.addUFOCustomData)({
                        fixedForgePageBannerWrapperHeight: height
                    });
                }
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: height
                    }
                } : undefined;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};









var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $lzgC6 = parcelRequire("lzgC6");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $lzgC6.default)()(class ReturnToMobileComponent extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4FKVYE5zaO _2uo31fDMqu _2fwxA5DIqT"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: this.getSwitchToMobileHref(),
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", (event)=>{
            event.preventDefault();
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
        $796a872a5806d472$var$_defineProperty(this, "getSwitchToMobileHref", ()=>{
            const { getQueryParams: getQueryParams } = this.props;
            const queryParams = getQueryParams();
            const url = new URL(window.location.href);
            if (queryParams.desktop === 'true') url.searchParams.delete('desktop');
             // Resulting URL is same page, non-desktop override
            return url.toString();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $cozmU.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");





var $9wGTI = parcelRequire("9wGTI");





var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");











function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner, ${(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)});
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner, isEarlyInitIframe = false) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer, isEarlyInitIframe);
    if (totalHeight) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $8wW9d = parcelRequire("8wW9d");


var $dizL5 = parcelRequire("dizL5");








var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    // Instrument the presence of non-content 3P background-script apps so their
    // keys are folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('background-script', forgeModules.map((app)=>app?.id));
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    })); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    } // Instrument the presence of non-content 3P page-banner apps so their keys are
    // folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('page-banner', forgeModules.map((app)=>app?.id)); // A shared preset height is only safe for one Custom UI banner; UI Kit does not use an iframe.
    const shouldPresetHeight = forgeModules.length === 1 && forgeModules[0]?.properties?.resource != null && forgeModules[0]?.properties?.render !== 'native';
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            shouldPresetHeight: shouldPresetHeight,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
});


const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_3iDTPbvLZJ",
    hidePanel: "_3iDTPbYbGa"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_23rrnH647S _0aFT5v1qpb _3TGfC9HnLE _39xV02N91d _2XsHFMPgdg _4eDzxwTTQh",
    addMinWidth: "_4ouGXIELL6"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_3iDTPbYbGa _42Yu6BaZ2J _39xV02N91d _1mT5xdy1CL _0KLXrulfZc _3OE6xY1nKm _1EqgXluI1V",
    showPanel: "_3iDTPbvLZJ"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrulfZc _24h04i2Njc _1RrJLiBwqQ _4kiQYAIZbP _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS = [
    (0, $hrAmX.BannerStateContainer)
];
const $4e0d0b830c02a893$var$getForgePageBannerPresetHeight = ()=>{
    try {
        const config = JSON.parse((0, $1xpoY.default).getString('confluence_forge_banner_preset_height', ''));
        return typeof config.presetHeight === 'number' ? config.presetHeight : 0;
    } catch  {
        return 0;
    }
};
const $4e0d0b830c02a893$var$MainLayoutInnerContent = ({ enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children, isLivePage: isLivePage, ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport, renderServerPlaceholder: renderServerPlaceholder })=>{
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, true, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $cozmU.useState)(false);
    const shouldRenderATLGeneralWebPanel = shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport;
    const shouldOmitATLFooterWebPanel = isEdit || isLivePage || ommitComponentsNotNeededForPdfExport || renderServerPlaceholder;
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    const forgePageBannerInitialHeight = $4e0d0b830c02a893$var$getForgePageBannerPresetHeight();
    const shouldUseForgePageBannerInitialHeight = forgePageBannerInitialHeight > 5;
    (0, $cozmU.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VjOtr"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const ForgePageBannerExtensionPoint = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            "_0jFU0VNIFp"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "forge-page-banner-wrapper-compiled",
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null));
    const mainLayoutContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            "confluence-main-content"
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldRenderATLGeneralWebPanel && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _313842dnbC _24h04i2Njc _2uxTLTZSoF _1mT5xdRAKS _39xV02N91d _3iDTPbQ4SZ _4kiQYAZqHV"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle
        }, children))), !shouldOmitATLFooterWebPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER),
        // server rendered, invalidating the hydrated DOM. ATL_GENERAL passes `cache-first`
        // for the same reason. `undefined` keeps the component default.
        fetchPolicy: (0, $6mKj3.expValEquals)('confluence_atl_footer_webpanel_cache_first', 'isEnabled', true) ? 'cache-first' : undefined
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)));
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: `.confluence-main-content .cp-container [role='dialog'] { z-index: 350; }`
        }
    }), mainLayoutContent) : null;
};
const $4e0d0b830c02a893$export$80006b81bf20e108 = (props)=>{
    const { isViewPage: isViewPage = false, isEdit: isEdit } = props;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const browserLocation = typeof globalThis.window?.location !== 'undefined' ? globalThis.window.location : undefined;
    const isPdfExport = browserLocation !== undefined && Boolean((0, $1NBp8.PDF_EXPORT_PAGE).match(browserLocation.pathname));
    const ommitComponentsNotNeededForPdfExport = isPdfExport && (0, $9wGTI.fg)('confluence_fe_omit_unneeded_comps_for_pdf_export');
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let webPanelBatchLocations = [];
    if (!ommitComponentsNotNeededForPdfExport) {
        if (isViewPage || isEdit) webPanelBatchLocations = [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ];
    }
    const shouldRenderWebPanelBatchProvider = webPanelBatchLocations.length > 0 && (0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$MainLayoutInnerContent, {
        ...props,
        isLivePage: isLivePage,
        ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport,
        renderServerPlaceholder: renderServerPlaceholder
    });
    return shouldRenderWebPanelBatchProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocationBatchProvider), {
        locations: webPanelBatchLocations
    }, content) : content;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $cozmU.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $cozmU.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZPtT.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content);
};


const $a171d54840e7d827$var$MainLayoutQuery = (0, $52181a874b01b0e6$export$2e2bcd8739ae039);
const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $cozmU.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $jMyy4.useQueryInterop)($a171d54840e7d827$var$MainLayoutQuery, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage,
        __callerPackage__: "main-layout"
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("5ZPtT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5ea117b10605f60a$export$6d1402fb58384e4f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OP-5u",
    name: "PageLayout",
    loader: async ()=>(await (parcelRequire("kG8cO"))).PageLayout
});
module.exports["PageLayout"] = $5ea117b10605f60a$export$6d1402fb58384e4f;

});

parcelRegister("kG8cO", function(module, exports) {

let $f0de185a5c28958b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f0de185a5c28958b$var$load("iY1NC"),
    $f0de185a5c28958b$var$load("lQ18T"),
    $f0de185a5c28958b$var$load("3R4oU"),
    $f0de185a5c28958b$var$load("3FSsi"),
    $f0de185a5c28958b$var$load("dMVmv"),
    $f0de185a5c28958b$var$load("aMsb0"),
    $f0de185a5c28958b$var$load("2PXrC"),
    $f0de185a5c28958b$var$load("j1vz1"),
    $f0de185a5c28958b$var$load("l2JSg"),
    $f0de185a5c28958b$var$load("h9mwG"),
    $f0de185a5c28958b$var$load("by9qp"),
    $f0de185a5c28958b$var$load("i6gwF"),
    $f0de185a5c28958b$var$load("6vqGz"),
    $f0de185a5c28958b$var$load("jzSMU"),
    $f0de185a5c28958b$var$load("bk398"),
    $f0de185a5c28958b$var$load("fHiQ2"),
    $f0de185a5c28958b$var$load("d8Sxi"),
    $f0de185a5c28958b$var$load("lkxmG"),
    $f0de185a5c28958b$var$load("2H1z2"),
    $f0de185a5c28958b$var$load("hSUDd"),
    $f0de185a5c28958b$var$load("6wr18"),
    $f0de185a5c28958b$var$load("jxLUH"),
    $f0de185a5c28958b$var$load("iFgab"),
    $f0de185a5c28958b$var$load("5nbvZ"),
    $f0de185a5c28958b$var$load("kebuF"),
    $f0de185a5c28958b$var$load("hohnS"),
    $f0de185a5c28958b$var$load("euiXy"),
    $f0de185a5c28958b$var$load("3DLgA"),
    $f0de185a5c28958b$var$load("2putD"),
    $f0de185a5c28958b$var$load("llcQo"),
    $f0de185a5c28958b$var$load("8tI7S"),
    $f0de185a5c28958b$var$load("eW2qV"),
    $f0de185a5c28958b$var$load("dgerE"),
    $f0de185a5c28958b$var$load("VXbA1"),
    $f0de185a5c28958b$var$load("el56J"),
    $f0de185a5c28958b$var$load("2PVCX"),
    $f0de185a5c28958b$var$load("aEiTV"),
    $f0de185a5c28958b$var$load("1qlDN"),
    $f0de185a5c28958b$var$load("1yVM6"),
    $f0de185a5c28958b$var$load("ea3NB"),
    $f0de185a5c28958b$var$load("bjgFk"),
    $f0de185a5c28958b$var$load("gKJFz"),
    $f0de185a5c28958b$var$load("aLbuU"),
    $f0de185a5c28958b$var$load("1SVGS"),
    $f0de185a5c28958b$var$load("gnalD"),
    $f0de185a5c28958b$var$load("ffEVr"),
    $f0de185a5c28958b$var$load("lEedB"),
    $f0de185a5c28958b$var$load("lsgAX"),
    $f0de185a5c28958b$var$load("ieLoM"),
    $f0de185a5c28958b$var$load("axFWL"),
    $f0de185a5c28958b$var$load("2qUvH"),
    $f0de185a5c28958b$var$load("7rfos"),
    $f0de185a5c28958b$var$load("dkfgY"),
    $f0de185a5c28958b$var$load("Wowvf"),
    $f0de185a5c28958b$var$load("dXOu8"),
    $f0de185a5c28958b$var$load("8jzRX"),
    $f0de185a5c28958b$var$load("dFbDj"),
    $f0de185a5c28958b$var$load("hhss7"),
    $f0de185a5c28958b$var$load("aAWLw"),
    $f0de185a5c28958b$var$load("7EorR"),
    $f0de185a5c28958b$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== moduleType) {
        t3 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[0] = moduleType;
        $[1] = t3;
    } else t3 = $[1];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t3);
    let t4;
    if ($[2] !== cloudId || $[3] !== contentId || $[4] !== locale || $[5] !== moduleType || $[6] !== queryOptions || $[7] !== resolvedAttachmentId || $[8] !== returnBlockedExtensions || $[9] !== skipQuery || $[10] !== spaceContextOnly || $[11] !== spaceKey) {
        t4 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[2] = cloudId;
        $[3] = contentId;
        $[4] = locale;
        $[5] = moduleType;
        $[6] = queryOptions;
        $[7] = resolvedAttachmentId;
        $[8] = returnBlockedExtensions;
        $[9] = skipQuery;
        $[10] = spaceContextOnly;
        $[11] = spaceKey;
        $[12] = t4;
    } else t4 = $[12];
    const options = t4;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t5;
    let t6;
    if ($[13] !== extsError || $[14] !== spaceError) {
        t5 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t6 = [
            extsError,
            spaceError
        ];
        $[13] = extsError;
        $[14] = spaceError;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) && !skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (0, $9wGTI.fg)("confluence_space_apps_ssr_preload")) {
        let t7;
        if ($[17] !== ssrExtensionResult.error || $[18] !== ssrExtensionResult.extensions) {
            t7 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[17] = ssrExtensionResult.error;
            $[18] = ssrExtensionResult.extensions;
            $[19] = t7;
        } else t7 = $[19];
        return t7;
    }
    let t7;
    if ($[20] !== extsData || $[21] !== extsError || $[22] !== extsLoading) {
        t7 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[20] = extsData;
        $[21] = extsError;
        $[22] = extsLoading;
        $[23] = t7;
    } else t7 = $[23];
    return t7;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) && !skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (0, $9wGTI.fg)('confluence_space_apps_ssr_preload')) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("6yagU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3Ap09 = parcelRequire("3Ap09");


var $dAzRS = parcelRequire("dAzRS");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null;
} : ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children } = t0;
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    let t1;
    if ($[0] !== closeAllPanels) {
        t1 = ()=>{
            closeAllPanels();
        };
        $[0] = closeAllPanels;
        $[1] = t1;
    } else t1 = $[1];
    const onPreviewPanelOpen = t1;
    let t2;
    if ($[2] !== closeOnlyPreviewPanel) {
        t2 = ()=>{
            closeOnlyPreviewPanel();
        };
        $[2] = closeOnlyPreviewPanel;
        $[3] = t2;
    } else t2 = $[3];
    const onPreviewPanelClose = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== onPreviewPanelClose || $[7] !== onPreviewPanelOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose,
            parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
        }, t3, children);
        $[5] = children;
        $[6] = onPreviewPanelClose;
        $[7] = onPreviewPanelOpen;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $cozmU.useCallback)(()=>{
        /*
    Any time a Preview Panel is opened in Confluence, we want to close all
    non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
    */ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $cozmU.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
    	Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
    	next panel are different, we want to close the previous panel before opening the new one. In order to
    	do this we need to pass the preview panel api
    */ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    let t0;
    let t1;
    if ($[0] !== closeOnlyPreviewPanel || $[1] !== location) {
        t0 = ()=>{
            const currentLocationKey = `${location.pathname}${location.search}`;
            const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
            if (currentLocationKey !== previousLocationKey) {
                closeOnlyPreviewPanel();
                previousLocation.current = location;
            }
        };
        t1 = [
            location,
            closeOnlyPreviewPanel
        ];
        $[0] = closeOnlyPreviewPanel;
        $[1] = location;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    (0, $cozmU.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $lRhY3 = parcelRequire("lRhY3");


var $3Ap09 = parcelRequire("3Ap09");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    let t0;
    if ($[0] !== hideObjectSidebar) {
        t0 = ()=>{
            window.dispatchEvent(new Event("closeGlobalSidebar"));
            hideObjectSidebar();
        };
        $[0] = hideObjectSidebar;
        $[1] = t0;
    } else t0 = $[1];
    const closeObjectSidebar = t0;
    let t1;
    if ($[2] !== close || $[3] !== context?.state?.panel) {
        t1 = (onClose)=>{
            if (context?.state?.panel) close(onClose);
        };
        $[2] = close;
        $[3] = context?.state?.panel;
        $[4] = t1;
    } else t1 = $[4];
    const closeOnlyPreviewPanel = t1;
    let t2;
    if ($[5] !== closeAll || $[6] !== closeObjectSidebar) {
        t2 = ()=>{
            closeAll();
            closeObjectSidebar();
        };
        $[5] = closeAll;
        $[6] = closeObjectSidebar;
        $[7] = t2;
    } else t2 = $[7];
    const closeAllPanels = t2;
    let t3;
    if ($[8] !== closeAllPanels || $[9] !== closeOnlyPreviewPanel) {
        t3 = {
            closeAllPanels: closeAllPanels,
            closeOnlyPreviewPanel: closeOnlyPreviewPanel
        };
        $[8] = closeAllPanels;
        $[9] = closeOnlyPreviewPanel;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Sidebar close is intentionally fire-and-forget
        hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("eG3Jj"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("4FJen"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("8pqjZ"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("fXgdm"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("ej7aI"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("56gaQ"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("aRjPB"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("Egk2a"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("fCX6f"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("2BvwB"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("in5NM"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("1Ycr4"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("eG3Jj", function(module, exports) {

let $aaf7e194b1d2a5b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aaf7e194b1d2a5b0$var$load("hUbK8"),
    $aaf7e194b1d2a5b0$var$load("LWh5V"),
    $aaf7e194b1d2a5b0$var$load("eNXrl"),
    $aaf7e194b1d2a5b0$var$load("2RkKX"),
    $aaf7e194b1d2a5b0$var$load("dZsGY"),
    $aaf7e194b1d2a5b0$var$load("1Gr4q"),
    $aaf7e194b1d2a5b0$var$load("6jUUE"),
    $aaf7e194b1d2a5b0$var$load("5lqi9"),
    $aaf7e194b1d2a5b0$var$load("7G12e"),
    $aaf7e194b1d2a5b0$var$load("4ARhS"),
    $aaf7e194b1d2a5b0$var$load("7EKNB"),
    $aaf7e194b1d2a5b0$var$load("4XoWv"),
    $aaf7e194b1d2a5b0$var$load("59hV4"),
    $aaf7e194b1d2a5b0$var$load("kwaPJ"),
    $aaf7e194b1d2a5b0$var$load("3ayyN"),
    $aaf7e194b1d2a5b0$var$load("aLwQm"),
    $aaf7e194b1d2a5b0$var$load("j1vz1"),
    $aaf7e194b1d2a5b0$var$load("l2JSg"),
    $aaf7e194b1d2a5b0$var$load("hh3iE"),
    $aaf7e194b1d2a5b0$var$load("bg4Qo"),
    $aaf7e194b1d2a5b0$var$load("4x9Jx"),
    $aaf7e194b1d2a5b0$var$load("kHXvF"),
    $aaf7e194b1d2a5b0$var$load("ea3NB"),
    $aaf7e194b1d2a5b0$var$load("by9qp"),
    $aaf7e194b1d2a5b0$var$load("i6gwF"),
    $aaf7e194b1d2a5b0$var$load("fuOfV"),
    $aaf7e194b1d2a5b0$var$load("jL1Ke"),
    $aaf7e194b1d2a5b0$var$load("5MQ0D"),
    $aaf7e194b1d2a5b0$var$load("exBMi"),
    $aaf7e194b1d2a5b0$var$load("6vqGz"),
    $aaf7e194b1d2a5b0$var$load("iBJWz"),
    $aaf7e194b1d2a5b0$var$load("cvcNg"),
    $aaf7e194b1d2a5b0$var$load("iZR3N"),
    $aaf7e194b1d2a5b0$var$load("jXM1T"),
    $aaf7e194b1d2a5b0$var$load("6wr18"),
    $aaf7e194b1d2a5b0$var$load("4N1MY"),
    $aaf7e194b1d2a5b0$var$load("ffEVr"),
    $aaf7e194b1d2a5b0$var$load("bk398"),
    $aaf7e194b1d2a5b0$var$load("fHiQ2"),
    $aaf7e194b1d2a5b0$var$load("axFWL"),
    $aaf7e194b1d2a5b0$var$load("2qUvH"),
    $aaf7e194b1d2a5b0$var$load("52ggd"),
    $aaf7e194b1d2a5b0$var$load("7rfos"),
    $aaf7e194b1d2a5b0$var$load("dkfgY"),
    $aaf7e194b1d2a5b0$var$load("h4Nf7"),
    $aaf7e194b1d2a5b0$var$load("Wowvf"),
    $aaf7e194b1d2a5b0$var$load("lkxmG"),
    $aaf7e194b1d2a5b0$var$load("dFbDj"),
    $aaf7e194b1d2a5b0$var$load("hhss7"),
    $aaf7e194b1d2a5b0$var$load("fGNl7"),
    $aaf7e194b1d2a5b0$var$load("lnKog"),
    $aaf7e194b1d2a5b0$var$load("aAWLw"),
    $aaf7e194b1d2a5b0$var$load("7EorR"),
    $aaf7e194b1d2a5b0$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("4FJen", function(module, exports) {

let $366e13a6637d5741$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $366e13a6637d5741$var$load("hUbK8"),
    $366e13a6637d5741$var$load("LWh5V"),
    $366e13a6637d5741$var$load("eNXrl"),
    $366e13a6637d5741$var$load("2RkKX"),
    $366e13a6637d5741$var$load("dZsGY"),
    $366e13a6637d5741$var$load("1Gr4q"),
    $366e13a6637d5741$var$load("6jUUE"),
    $366e13a6637d5741$var$load("5lqi9"),
    $366e13a6637d5741$var$load("7G12e"),
    $366e13a6637d5741$var$load("4ARhS"),
    $366e13a6637d5741$var$load("7EKNB"),
    $366e13a6637d5741$var$load("4XoWv"),
    $366e13a6637d5741$var$load("59hV4"),
    $366e13a6637d5741$var$load("kwaPJ"),
    $366e13a6637d5741$var$load("3ayyN"),
    $366e13a6637d5741$var$load("aLwQm"),
    $366e13a6637d5741$var$load("j1vz1"),
    $366e13a6637d5741$var$load("l2JSg"),
    $366e13a6637d5741$var$load("hh3iE"),
    $366e13a6637d5741$var$load("bg4Qo"),
    $366e13a6637d5741$var$load("4x9Jx"),
    $366e13a6637d5741$var$load("kHXvF"),
    $366e13a6637d5741$var$load("ea3NB"),
    $366e13a6637d5741$var$load("by9qp"),
    $366e13a6637d5741$var$load("i6gwF"),
    $366e13a6637d5741$var$load("fuOfV"),
    $366e13a6637d5741$var$load("jL1Ke"),
    $366e13a6637d5741$var$load("5MQ0D"),
    $366e13a6637d5741$var$load("exBMi"),
    $366e13a6637d5741$var$load("6vqGz"),
    $366e13a6637d5741$var$load("iBJWz"),
    $366e13a6637d5741$var$load("cvcNg"),
    $366e13a6637d5741$var$load("iZR3N"),
    $366e13a6637d5741$var$load("jXM1T"),
    $366e13a6637d5741$var$load("6wr18"),
    $366e13a6637d5741$var$load("4N1MY"),
    $366e13a6637d5741$var$load("ffEVr"),
    $366e13a6637d5741$var$load("bk398"),
    $366e13a6637d5741$var$load("fHiQ2"),
    $366e13a6637d5741$var$load("axFWL"),
    $366e13a6637d5741$var$load("2qUvH"),
    $366e13a6637d5741$var$load("52ggd"),
    $366e13a6637d5741$var$load("7rfos"),
    $366e13a6637d5741$var$load("dkfgY"),
    $366e13a6637d5741$var$load("h4Nf7"),
    $366e13a6637d5741$var$load("Wowvf"),
    $366e13a6637d5741$var$load("lkxmG"),
    $366e13a6637d5741$var$load("dFbDj"),
    $366e13a6637d5741$var$load("hhss7"),
    $366e13a6637d5741$var$load("fGNl7"),
    $366e13a6637d5741$var$load("lnKog"),
    $366e13a6637d5741$var$load("aAWLw"),
    $366e13a6637d5741$var$load("7EorR"),
    $366e13a6637d5741$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("8pqjZ", function(module, exports) {

let $61f5136ea42e354c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $61f5136ea42e354c$var$load("hUbK8"),
    $61f5136ea42e354c$var$load("LWh5V"),
    $61f5136ea42e354c$var$load("eNXrl"),
    $61f5136ea42e354c$var$load("2RkKX"),
    $61f5136ea42e354c$var$load("dZsGY"),
    $61f5136ea42e354c$var$load("1Gr4q"),
    $61f5136ea42e354c$var$load("6jUUE"),
    $61f5136ea42e354c$var$load("5lqi9"),
    $61f5136ea42e354c$var$load("7G12e"),
    $61f5136ea42e354c$var$load("4ARhS"),
    $61f5136ea42e354c$var$load("7EKNB"),
    $61f5136ea42e354c$var$load("4XoWv"),
    $61f5136ea42e354c$var$load("59hV4"),
    $61f5136ea42e354c$var$load("kwaPJ"),
    $61f5136ea42e354c$var$load("3ayyN"),
    $61f5136ea42e354c$var$load("aLwQm"),
    $61f5136ea42e354c$var$load("j1vz1"),
    $61f5136ea42e354c$var$load("l2JSg"),
    $61f5136ea42e354c$var$load("hh3iE"),
    $61f5136ea42e354c$var$load("bg4Qo"),
    $61f5136ea42e354c$var$load("4x9Jx"),
    $61f5136ea42e354c$var$load("kHXvF"),
    $61f5136ea42e354c$var$load("ea3NB"),
    $61f5136ea42e354c$var$load("by9qp"),
    $61f5136ea42e354c$var$load("i6gwF"),
    $61f5136ea42e354c$var$load("fuOfV"),
    $61f5136ea42e354c$var$load("jL1Ke"),
    $61f5136ea42e354c$var$load("5MQ0D"),
    $61f5136ea42e354c$var$load("exBMi"),
    $61f5136ea42e354c$var$load("6vqGz"),
    $61f5136ea42e354c$var$load("iBJWz"),
    $61f5136ea42e354c$var$load("cvcNg"),
    $61f5136ea42e354c$var$load("iZR3N"),
    $61f5136ea42e354c$var$load("jXM1T"),
    $61f5136ea42e354c$var$load("6wr18"),
    $61f5136ea42e354c$var$load("4N1MY"),
    $61f5136ea42e354c$var$load("ffEVr"),
    $61f5136ea42e354c$var$load("bk398"),
    $61f5136ea42e354c$var$load("fHiQ2"),
    $61f5136ea42e354c$var$load("axFWL"),
    $61f5136ea42e354c$var$load("2qUvH"),
    $61f5136ea42e354c$var$load("52ggd"),
    $61f5136ea42e354c$var$load("7rfos"),
    $61f5136ea42e354c$var$load("dkfgY"),
    $61f5136ea42e354c$var$load("h4Nf7"),
    $61f5136ea42e354c$var$load("Wowvf"),
    $61f5136ea42e354c$var$load("lkxmG"),
    $61f5136ea42e354c$var$load("dFbDj"),
    $61f5136ea42e354c$var$load("hhss7"),
    $61f5136ea42e354c$var$load("fGNl7"),
    $61f5136ea42e354c$var$load("lnKog"),
    $61f5136ea42e354c$var$load("aAWLw"),
    $61f5136ea42e354c$var$load("7EorR"),
    $61f5136ea42e354c$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("fXgdm", function(module, exports) {

let $b9d8f18b9d08bcdd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9d8f18b9d08bcdd$var$load("hUbK8"),
    $b9d8f18b9d08bcdd$var$load("2RkKX"),
    $b9d8f18b9d08bcdd$var$load("1Gr4q"),
    $b9d8f18b9d08bcdd$var$load("6jUUE"),
    $b9d8f18b9d08bcdd$var$load("5lqi9"),
    $b9d8f18b9d08bcdd$var$load("7G12e"),
    $b9d8f18b9d08bcdd$var$load("4ARhS"),
    $b9d8f18b9d08bcdd$var$load("7EKNB"),
    $b9d8f18b9d08bcdd$var$load("4XoWv"),
    $b9d8f18b9d08bcdd$var$load("kwaPJ"),
    $b9d8f18b9d08bcdd$var$load("3ayyN"),
    $b9d8f18b9d08bcdd$var$load("aLwQm"),
    $b9d8f18b9d08bcdd$var$load("j1vz1"),
    $b9d8f18b9d08bcdd$var$load("l2JSg"),
    $b9d8f18b9d08bcdd$var$load("4x9Jx"),
    $b9d8f18b9d08bcdd$var$load("kHXvF"),
    $b9d8f18b9d08bcdd$var$load("ea3NB"),
    $b9d8f18b9d08bcdd$var$load("by9qp"),
    $b9d8f18b9d08bcdd$var$load("i6gwF"),
    $b9d8f18b9d08bcdd$var$load("exBMi"),
    $b9d8f18b9d08bcdd$var$load("6vqGz"),
    $b9d8f18b9d08bcdd$var$load("iBJWz"),
    $b9d8f18b9d08bcdd$var$load("cvcNg"),
    $b9d8f18b9d08bcdd$var$load("iZR3N"),
    $b9d8f18b9d08bcdd$var$load("jXM1T"),
    $b9d8f18b9d08bcdd$var$load("6wr18"),
    $b9d8f18b9d08bcdd$var$load("4N1MY"),
    $b9d8f18b9d08bcdd$var$load("ffEVr"),
    $b9d8f18b9d08bcdd$var$load("bk398"),
    $b9d8f18b9d08bcdd$var$load("fHiQ2"),
    $b9d8f18b9d08bcdd$var$load("axFWL"),
    $b9d8f18b9d08bcdd$var$load("2qUvH"),
    $b9d8f18b9d08bcdd$var$load("fGNl7"),
    $b9d8f18b9d08bcdd$var$load("52ggd"),
    $b9d8f18b9d08bcdd$var$load("7rfos"),
    $b9d8f18b9d08bcdd$var$load("dkfgY"),
    $b9d8f18b9d08bcdd$var$load("h4Nf7"),
    $b9d8f18b9d08bcdd$var$load("Wowvf"),
    $b9d8f18b9d08bcdd$var$load("lkxmG"),
    $b9d8f18b9d08bcdd$var$load("dFbDj"),
    $b9d8f18b9d08bcdd$var$load("hhss7"),
    $b9d8f18b9d08bcdd$var$load("aAWLw"),
    $b9d8f18b9d08bcdd$var$load("7EorR"),
    $b9d8f18b9d08bcdd$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("ej7aI", function(module, exports) {

let $a6a86739878d2b95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6a86739878d2b95$var$load("hUbK8"),
    $a6a86739878d2b95$var$load("2RkKX"),
    $a6a86739878d2b95$var$load("1Gr4q"),
    $a6a86739878d2b95$var$load("6jUUE"),
    $a6a86739878d2b95$var$load("5lqi9"),
    $a6a86739878d2b95$var$load("7G12e"),
    $a6a86739878d2b95$var$load("4ARhS"),
    $a6a86739878d2b95$var$load("7EKNB"),
    $a6a86739878d2b95$var$load("4XoWv"),
    $a6a86739878d2b95$var$load("kwaPJ"),
    $a6a86739878d2b95$var$load("3ayyN"),
    $a6a86739878d2b95$var$load("aLwQm"),
    $a6a86739878d2b95$var$load("j1vz1"),
    $a6a86739878d2b95$var$load("l2JSg"),
    $a6a86739878d2b95$var$load("4x9Jx"),
    $a6a86739878d2b95$var$load("kHXvF"),
    $a6a86739878d2b95$var$load("ea3NB"),
    $a6a86739878d2b95$var$load("by9qp"),
    $a6a86739878d2b95$var$load("i6gwF"),
    $a6a86739878d2b95$var$load("exBMi"),
    $a6a86739878d2b95$var$load("6vqGz"),
    $a6a86739878d2b95$var$load("iBJWz"),
    $a6a86739878d2b95$var$load("cvcNg"),
    $a6a86739878d2b95$var$load("iZR3N"),
    $a6a86739878d2b95$var$load("jXM1T"),
    $a6a86739878d2b95$var$load("6wr18"),
    $a6a86739878d2b95$var$load("4N1MY"),
    $a6a86739878d2b95$var$load("ffEVr"),
    $a6a86739878d2b95$var$load("bk398"),
    $a6a86739878d2b95$var$load("fHiQ2"),
    $a6a86739878d2b95$var$load("axFWL"),
    $a6a86739878d2b95$var$load("2qUvH"),
    $a6a86739878d2b95$var$load("fGNl7"),
    $a6a86739878d2b95$var$load("52ggd"),
    $a6a86739878d2b95$var$load("7rfos"),
    $a6a86739878d2b95$var$load("dkfgY"),
    $a6a86739878d2b95$var$load("h4Nf7"),
    $a6a86739878d2b95$var$load("Wowvf"),
    $a6a86739878d2b95$var$load("lkxmG"),
    $a6a86739878d2b95$var$load("dFbDj"),
    $a6a86739878d2b95$var$load("hhss7"),
    $a6a86739878d2b95$var$load("aAWLw"),
    $a6a86739878d2b95$var$load("7EorR"),
    $a6a86739878d2b95$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("56gaQ", function(module, exports) {

let $3b6a0f14903b1bbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b6a0f14903b1bbf$var$load("hUbK8"),
    $3b6a0f14903b1bbf$var$load("2RkKX"),
    $3b6a0f14903b1bbf$var$load("1Gr4q"),
    $3b6a0f14903b1bbf$var$load("6jUUE"),
    $3b6a0f14903b1bbf$var$load("5lqi9"),
    $3b6a0f14903b1bbf$var$load("7G12e"),
    $3b6a0f14903b1bbf$var$load("4ARhS"),
    $3b6a0f14903b1bbf$var$load("7EKNB"),
    $3b6a0f14903b1bbf$var$load("4XoWv"),
    $3b6a0f14903b1bbf$var$load("kwaPJ"),
    $3b6a0f14903b1bbf$var$load("3ayyN"),
    $3b6a0f14903b1bbf$var$load("aLwQm"),
    $3b6a0f14903b1bbf$var$load("j1vz1"),
    $3b6a0f14903b1bbf$var$load("l2JSg"),
    $3b6a0f14903b1bbf$var$load("4x9Jx"),
    $3b6a0f14903b1bbf$var$load("kHXvF"),
    $3b6a0f14903b1bbf$var$load("ea3NB"),
    $3b6a0f14903b1bbf$var$load("by9qp"),
    $3b6a0f14903b1bbf$var$load("i6gwF"),
    $3b6a0f14903b1bbf$var$load("exBMi"),
    $3b6a0f14903b1bbf$var$load("6vqGz"),
    $3b6a0f14903b1bbf$var$load("iBJWz"),
    $3b6a0f14903b1bbf$var$load("cvcNg"),
    $3b6a0f14903b1bbf$var$load("iZR3N"),
    $3b6a0f14903b1bbf$var$load("jXM1T"),
    $3b6a0f14903b1bbf$var$load("6wr18"),
    $3b6a0f14903b1bbf$var$load("4N1MY"),
    $3b6a0f14903b1bbf$var$load("ffEVr"),
    $3b6a0f14903b1bbf$var$load("bk398"),
    $3b6a0f14903b1bbf$var$load("fHiQ2"),
    $3b6a0f14903b1bbf$var$load("axFWL"),
    $3b6a0f14903b1bbf$var$load("2qUvH"),
    $3b6a0f14903b1bbf$var$load("fGNl7"),
    $3b6a0f14903b1bbf$var$load("52ggd"),
    $3b6a0f14903b1bbf$var$load("7rfos"),
    $3b6a0f14903b1bbf$var$load("dkfgY"),
    $3b6a0f14903b1bbf$var$load("h4Nf7"),
    $3b6a0f14903b1bbf$var$load("Wowvf"),
    $3b6a0f14903b1bbf$var$load("lkxmG"),
    $3b6a0f14903b1bbf$var$load("dFbDj"),
    $3b6a0f14903b1bbf$var$load("hhss7"),
    $3b6a0f14903b1bbf$var$load("aAWLw"),
    $3b6a0f14903b1bbf$var$load("7EorR"),
    $3b6a0f14903b1bbf$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("aRjPB", function(module, exports) {

let $7e7e3caea5053339$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e7e3caea5053339$var$load("hUbK8"),
    $7e7e3caea5053339$var$load("2RkKX"),
    $7e7e3caea5053339$var$load("1Gr4q"),
    $7e7e3caea5053339$var$load("6jUUE"),
    $7e7e3caea5053339$var$load("5lqi9"),
    $7e7e3caea5053339$var$load("7G12e"),
    $7e7e3caea5053339$var$load("4ARhS"),
    $7e7e3caea5053339$var$load("7EKNB"),
    $7e7e3caea5053339$var$load("4XoWv"),
    $7e7e3caea5053339$var$load("kwaPJ"),
    $7e7e3caea5053339$var$load("3ayyN"),
    $7e7e3caea5053339$var$load("aLwQm"),
    $7e7e3caea5053339$var$load("j1vz1"),
    $7e7e3caea5053339$var$load("l2JSg"),
    $7e7e3caea5053339$var$load("4x9Jx"),
    $7e7e3caea5053339$var$load("kHXvF"),
    $7e7e3caea5053339$var$load("ea3NB"),
    $7e7e3caea5053339$var$load("by9qp"),
    $7e7e3caea5053339$var$load("i6gwF"),
    $7e7e3caea5053339$var$load("exBMi"),
    $7e7e3caea5053339$var$load("6vqGz"),
    $7e7e3caea5053339$var$load("iBJWz"),
    $7e7e3caea5053339$var$load("cvcNg"),
    $7e7e3caea5053339$var$load("iZR3N"),
    $7e7e3caea5053339$var$load("jXM1T"),
    $7e7e3caea5053339$var$load("6wr18"),
    $7e7e3caea5053339$var$load("4N1MY"),
    $7e7e3caea5053339$var$load("ffEVr"),
    $7e7e3caea5053339$var$load("bk398"),
    $7e7e3caea5053339$var$load("fHiQ2"),
    $7e7e3caea5053339$var$load("axFWL"),
    $7e7e3caea5053339$var$load("2qUvH"),
    $7e7e3caea5053339$var$load("52ggd"),
    $7e7e3caea5053339$var$load("7rfos"),
    $7e7e3caea5053339$var$load("dkfgY"),
    $7e7e3caea5053339$var$load("h4Nf7"),
    $7e7e3caea5053339$var$load("Wowvf"),
    $7e7e3caea5053339$var$load("lkxmG"),
    $7e7e3caea5053339$var$load("dFbDj"),
    $7e7e3caea5053339$var$load("hhss7"),
    $7e7e3caea5053339$var$load("fGNl7"),
    $7e7e3caea5053339$var$load("lnKog"),
    $7e7e3caea5053339$var$load("aAWLw"),
    $7e7e3caea5053339$var$load("7EorR"),
    $7e7e3caea5053339$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("Egk2a", function(module, exports) {

let $079065c6ae26af19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $079065c6ae26af19$var$load("hUbK8"),
    $079065c6ae26af19$var$load("2RkKX"),
    $079065c6ae26af19$var$load("dZsGY"),
    $079065c6ae26af19$var$load("1Gr4q"),
    $079065c6ae26af19$var$load("6jUUE"),
    $079065c6ae26af19$var$load("5lqi9"),
    $079065c6ae26af19$var$load("7G12e"),
    $079065c6ae26af19$var$load("4ARhS"),
    $079065c6ae26af19$var$load("7EKNB"),
    $079065c6ae26af19$var$load("4XoWv"),
    $079065c6ae26af19$var$load("59hV4"),
    $079065c6ae26af19$var$load("kwaPJ"),
    $079065c6ae26af19$var$load("3ayyN"),
    $079065c6ae26af19$var$load("aLwQm"),
    $079065c6ae26af19$var$load("j1vz1"),
    $079065c6ae26af19$var$load("l2JSg"),
    $079065c6ae26af19$var$load("hh3iE"),
    $079065c6ae26af19$var$load("bg4Qo"),
    $079065c6ae26af19$var$load("4x9Jx"),
    $079065c6ae26af19$var$load("kHXvF"),
    $079065c6ae26af19$var$load("ea3NB"),
    $079065c6ae26af19$var$load("by9qp"),
    $079065c6ae26af19$var$load("i6gwF"),
    $079065c6ae26af19$var$load("fuOfV"),
    $079065c6ae26af19$var$load("jL1Ke"),
    $079065c6ae26af19$var$load("5MQ0D"),
    $079065c6ae26af19$var$load("exBMi"),
    $079065c6ae26af19$var$load("6vqGz"),
    $079065c6ae26af19$var$load("iBJWz"),
    $079065c6ae26af19$var$load("cvcNg"),
    $079065c6ae26af19$var$load("iZR3N"),
    $079065c6ae26af19$var$load("jXM1T"),
    $079065c6ae26af19$var$load("6wr18"),
    $079065c6ae26af19$var$load("4N1MY"),
    $079065c6ae26af19$var$load("ffEVr"),
    $079065c6ae26af19$var$load("bk398"),
    $079065c6ae26af19$var$load("fHiQ2"),
    $079065c6ae26af19$var$load("axFWL"),
    $079065c6ae26af19$var$load("2qUvH"),
    $079065c6ae26af19$var$load("52ggd"),
    $079065c6ae26af19$var$load("7rfos"),
    $079065c6ae26af19$var$load("dkfgY"),
    $079065c6ae26af19$var$load("h4Nf7"),
    $079065c6ae26af19$var$load("Wowvf"),
    $079065c6ae26af19$var$load("lkxmG"),
    $079065c6ae26af19$var$load("dFbDj"),
    $079065c6ae26af19$var$load("hhss7"),
    $079065c6ae26af19$var$load("fGNl7"),
    $079065c6ae26af19$var$load("lnKog"),
    $079065c6ae26af19$var$load("aAWLw"),
    $079065c6ae26af19$var$load("7EorR"),
    $079065c6ae26af19$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("fCX6f", function(module, exports) {

let $b6083f99f7268eff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b6083f99f7268eff$var$load("hUbK8"),
    $b6083f99f7268eff$var$load("2RkKX"),
    $b6083f99f7268eff$var$load("dZsGY"),
    $b6083f99f7268eff$var$load("1Gr4q"),
    $b6083f99f7268eff$var$load("6jUUE"),
    $b6083f99f7268eff$var$load("5lqi9"),
    $b6083f99f7268eff$var$load("7G12e"),
    $b6083f99f7268eff$var$load("4ARhS"),
    $b6083f99f7268eff$var$load("7EKNB"),
    $b6083f99f7268eff$var$load("4XoWv"),
    $b6083f99f7268eff$var$load("59hV4"),
    $b6083f99f7268eff$var$load("kwaPJ"),
    $b6083f99f7268eff$var$load("3ayyN"),
    $b6083f99f7268eff$var$load("aLwQm"),
    $b6083f99f7268eff$var$load("j1vz1"),
    $b6083f99f7268eff$var$load("l2JSg"),
    $b6083f99f7268eff$var$load("hh3iE"),
    $b6083f99f7268eff$var$load("bg4Qo"),
    $b6083f99f7268eff$var$load("4x9Jx"),
    $b6083f99f7268eff$var$load("kHXvF"),
    $b6083f99f7268eff$var$load("ea3NB"),
    $b6083f99f7268eff$var$load("by9qp"),
    $b6083f99f7268eff$var$load("i6gwF"),
    $b6083f99f7268eff$var$load("fuOfV"),
    $b6083f99f7268eff$var$load("jL1Ke"),
    $b6083f99f7268eff$var$load("5MQ0D"),
    $b6083f99f7268eff$var$load("exBMi"),
    $b6083f99f7268eff$var$load("6vqGz"),
    $b6083f99f7268eff$var$load("iBJWz"),
    $b6083f99f7268eff$var$load("cvcNg"),
    $b6083f99f7268eff$var$load("iZR3N"),
    $b6083f99f7268eff$var$load("jXM1T"),
    $b6083f99f7268eff$var$load("6wr18"),
    $b6083f99f7268eff$var$load("4N1MY"),
    $b6083f99f7268eff$var$load("ffEVr"),
    $b6083f99f7268eff$var$load("bk398"),
    $b6083f99f7268eff$var$load("fHiQ2"),
    $b6083f99f7268eff$var$load("axFWL"),
    $b6083f99f7268eff$var$load("2qUvH"),
    $b6083f99f7268eff$var$load("52ggd"),
    $b6083f99f7268eff$var$load("7rfos"),
    $b6083f99f7268eff$var$load("dkfgY"),
    $b6083f99f7268eff$var$load("h4Nf7"),
    $b6083f99f7268eff$var$load("Wowvf"),
    $b6083f99f7268eff$var$load("lkxmG"),
    $b6083f99f7268eff$var$load("dFbDj"),
    $b6083f99f7268eff$var$load("hhss7"),
    $b6083f99f7268eff$var$load("fGNl7"),
    $b6083f99f7268eff$var$load("lnKog"),
    $b6083f99f7268eff$var$load("aAWLw"),
    $b6083f99f7268eff$var$load("7EorR"),
    $b6083f99f7268eff$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("2BvwB", function(module, exports) {

let $1e577da4e0732134$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1e577da4e0732134$var$load("hUbK8"),
    $1e577da4e0732134$var$load("2RkKX"),
    $1e577da4e0732134$var$load("1Gr4q"),
    $1e577da4e0732134$var$load("6jUUE"),
    $1e577da4e0732134$var$load("5lqi9"),
    $1e577da4e0732134$var$load("7G12e"),
    $1e577da4e0732134$var$load("4ARhS"),
    $1e577da4e0732134$var$load("7EKNB"),
    $1e577da4e0732134$var$load("4XoWv"),
    $1e577da4e0732134$var$load("kwaPJ"),
    $1e577da4e0732134$var$load("3ayyN"),
    $1e577da4e0732134$var$load("aLwQm"),
    $1e577da4e0732134$var$load("j1vz1"),
    $1e577da4e0732134$var$load("l2JSg"),
    $1e577da4e0732134$var$load("4x9Jx"),
    $1e577da4e0732134$var$load("kHXvF"),
    $1e577da4e0732134$var$load("ea3NB"),
    $1e577da4e0732134$var$load("by9qp"),
    $1e577da4e0732134$var$load("i6gwF"),
    $1e577da4e0732134$var$load("exBMi"),
    $1e577da4e0732134$var$load("6vqGz"),
    $1e577da4e0732134$var$load("iBJWz"),
    $1e577da4e0732134$var$load("cvcNg"),
    $1e577da4e0732134$var$load("iZR3N"),
    $1e577da4e0732134$var$load("jXM1T"),
    $1e577da4e0732134$var$load("6wr18"),
    $1e577da4e0732134$var$load("4N1MY"),
    $1e577da4e0732134$var$load("ffEVr"),
    $1e577da4e0732134$var$load("bk398"),
    $1e577da4e0732134$var$load("fHiQ2"),
    $1e577da4e0732134$var$load("axFWL"),
    $1e577da4e0732134$var$load("2qUvH"),
    $1e577da4e0732134$var$load("fGNl7"),
    $1e577da4e0732134$var$load("52ggd"),
    $1e577da4e0732134$var$load("7rfos"),
    $1e577da4e0732134$var$load("dkfgY"),
    $1e577da4e0732134$var$load("h4Nf7"),
    $1e577da4e0732134$var$load("Wowvf"),
    $1e577da4e0732134$var$load("lkxmG"),
    $1e577da4e0732134$var$load("dFbDj"),
    $1e577da4e0732134$var$load("hhss7"),
    $1e577da4e0732134$var$load("aAWLw"),
    $1e577da4e0732134$var$load("7EorR"),
    $1e577da4e0732134$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("in5NM", function(module, exports) {

let $d5fee018d7aefd06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5fee018d7aefd06$var$load("hUbK8"),
    $d5fee018d7aefd06$var$load("2RkKX"),
    $d5fee018d7aefd06$var$load("1Gr4q"),
    $d5fee018d7aefd06$var$load("6jUUE"),
    $d5fee018d7aefd06$var$load("5lqi9"),
    $d5fee018d7aefd06$var$load("7G12e"),
    $d5fee018d7aefd06$var$load("4ARhS"),
    $d5fee018d7aefd06$var$load("7EKNB"),
    $d5fee018d7aefd06$var$load("4XoWv"),
    $d5fee018d7aefd06$var$load("kwaPJ"),
    $d5fee018d7aefd06$var$load("3ayyN"),
    $d5fee018d7aefd06$var$load("aLwQm"),
    $d5fee018d7aefd06$var$load("j1vz1"),
    $d5fee018d7aefd06$var$load("l2JSg"),
    $d5fee018d7aefd06$var$load("4x9Jx"),
    $d5fee018d7aefd06$var$load("kHXvF"),
    $d5fee018d7aefd06$var$load("ea3NB"),
    $d5fee018d7aefd06$var$load("by9qp"),
    $d5fee018d7aefd06$var$load("i6gwF"),
    $d5fee018d7aefd06$var$load("exBMi"),
    $d5fee018d7aefd06$var$load("6vqGz"),
    $d5fee018d7aefd06$var$load("iBJWz"),
    $d5fee018d7aefd06$var$load("cvcNg"),
    $d5fee018d7aefd06$var$load("iZR3N"),
    $d5fee018d7aefd06$var$load("jXM1T"),
    $d5fee018d7aefd06$var$load("6wr18"),
    $d5fee018d7aefd06$var$load("4N1MY"),
    $d5fee018d7aefd06$var$load("ffEVr"),
    $d5fee018d7aefd06$var$load("bk398"),
    $d5fee018d7aefd06$var$load("fHiQ2"),
    $d5fee018d7aefd06$var$load("axFWL"),
    $d5fee018d7aefd06$var$load("2qUvH"),
    $d5fee018d7aefd06$var$load("52ggd"),
    $d5fee018d7aefd06$var$load("7rfos"),
    $d5fee018d7aefd06$var$load("dkfgY"),
    $d5fee018d7aefd06$var$load("h4Nf7"),
    $d5fee018d7aefd06$var$load("Wowvf"),
    $d5fee018d7aefd06$var$load("lkxmG"),
    $d5fee018d7aefd06$var$load("dFbDj"),
    $d5fee018d7aefd06$var$load("hhss7"),
    $d5fee018d7aefd06$var$load("fGNl7"),
    $d5fee018d7aefd06$var$load("lnKog"),
    $d5fee018d7aefd06$var$load("aAWLw"),
    $d5fee018d7aefd06$var$load("7EorR"),
    $d5fee018d7aefd06$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("1Ycr4", function(module, exports) {

let $16f50a7d082946b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $16f50a7d082946b3$var$load("hUbK8"),
    $16f50a7d082946b3$var$load("2RkKX"),
    $16f50a7d082946b3$var$load("1Gr4q"),
    $16f50a7d082946b3$var$load("6jUUE"),
    $16f50a7d082946b3$var$load("5lqi9"),
    $16f50a7d082946b3$var$load("7G12e"),
    $16f50a7d082946b3$var$load("4ARhS"),
    $16f50a7d082946b3$var$load("7EKNB"),
    $16f50a7d082946b3$var$load("4XoWv"),
    $16f50a7d082946b3$var$load("kwaPJ"),
    $16f50a7d082946b3$var$load("3ayyN"),
    $16f50a7d082946b3$var$load("aLwQm"),
    $16f50a7d082946b3$var$load("j1vz1"),
    $16f50a7d082946b3$var$load("l2JSg"),
    $16f50a7d082946b3$var$load("4x9Jx"),
    $16f50a7d082946b3$var$load("kHXvF"),
    $16f50a7d082946b3$var$load("ea3NB"),
    $16f50a7d082946b3$var$load("by9qp"),
    $16f50a7d082946b3$var$load("i6gwF"),
    $16f50a7d082946b3$var$load("exBMi"),
    $16f50a7d082946b3$var$load("6vqGz"),
    $16f50a7d082946b3$var$load("iBJWz"),
    $16f50a7d082946b3$var$load("cvcNg"),
    $16f50a7d082946b3$var$load("iZR3N"),
    $16f50a7d082946b3$var$load("jXM1T"),
    $16f50a7d082946b3$var$load("6wr18"),
    $16f50a7d082946b3$var$load("4N1MY"),
    $16f50a7d082946b3$var$load("ffEVr"),
    $16f50a7d082946b3$var$load("bk398"),
    $16f50a7d082946b3$var$load("fHiQ2"),
    $16f50a7d082946b3$var$load("axFWL"),
    $16f50a7d082946b3$var$load("2qUvH"),
    $16f50a7d082946b3$var$load("52ggd"),
    $16f50a7d082946b3$var$load("7rfos"),
    $16f50a7d082946b3$var$load("dkfgY"),
    $16f50a7d082946b3$var$load("h4Nf7"),
    $16f50a7d082946b3$var$load("Wowvf"),
    $16f50a7d082946b3$var$load("lkxmG"),
    $16f50a7d082946b3$var$load("dFbDj"),
    $16f50a7d082946b3$var$load("hhss7"),
    $16f50a7d082946b3$var$load("fGNl7"),
    $16f50a7d082946b3$var$load("lnKog"),
    $16f50a7d082946b3$var$load("aAWLw"),
    $16f50a7d082946b3$var$load("7EorR"),
    $16f50a7d082946b3$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("04qh3"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("04qh3", function(module, exports) {

let $00d4c153bc0a88fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $00d4c153bc0a88fb$var$load("fGNl7"),
    $00d4c153bc0a88fb$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.0b329d71.js.map
